import React from "react";
import GoogleAvatar from "./GoogleAvatar";

interface GoogleAuthProps {
  userProfile: { name: string; picture: string } | null;
  onLogout: () => void;
}

const GoogleAuth: React.FC<GoogleAuthProps> = ({ userProfile, onLogout }) => {
  // Only render this component if the user is logged in
  if (!userProfile) {
    return <div className="h-[68px]"></div>; // Reserve space in header
  }

  return (
    <div className="flex items-center justify-end p-4">
      <div className="flex items-center gap-4">
        <GoogleAvatar
          key={userProfile.picture}
          src={userProfile.picture}
          name={userProfile.name}
          size={40}
          className="rounded-full"
          fallbackClassName="rounded-full bg-navy-mid"
        />
        <p className="text-rose-accent hidden sm:block">Welcome, {userProfile.name.split(' ')[0]}!</p>
        <button
          onClick={onLogout}
          className="bg-navy-mid hover:bg-navy-light text-status-danger border border-border-strong font-bold py-2 px-4 rounded transition-colors"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default GoogleAuth;
